import { useState } from "react";
import { Mail, CheckCircle2, Loader2 } from "lucide-react";
import { useSettings } from "@/lib/content";
import { submitNewsletter, recordAbConversions, abExtra } from "@/lib/api";

// Footer newsletter signup. Ships DISABLED so the public site is unchanged by
// default — the admin turns it on and edits the copy in Site settings. When off
// this renders nothing (design stays pixel-identical to the shipped footer).
export default function NewsletterSignup() {
  const settings = useSettings({});
  const cfg = settings.newsletter || {};
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | done

  if (!cfg.enabled) return null;

  const submit = async (e) => {
    e.preventDefault();
    const value = email.trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) return;
    setState("loading");
    try {
      await submitNewsletter(value, { page_url: typeof window !== "undefined" ? window.location.pathname : undefined, extra: abExtra() });
      recordAbConversions();
      setState("done");
      setEmail("");
    } catch {
      setState("idle");
    }
  };

  const title = cfg.title || "Stay in the loop";
  const subtitle = cfg.subtitle || "IT and cyber-security tips for UK businesses — occasional, never spammy.";
  const buttonLabel = cfg.buttonLabel || "Subscribe";
  const successText = cfg.successText || "Thanks — you're on the list.";

  return (
    <div className="mt-14 rounded-2xl border border-slate-200 bg-slate-50 p-6 sm:p-8">
      <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
        <div className="max-w-md">
          <p className="font-heading text-lg font-semibold text-slate-900">{title}</p>
          <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
        </div>
        {state === "done" ? (
          <p className="flex items-center gap-2 text-sm font-medium text-emerald-600">
            <CheckCircle2 className="h-5 w-5" /> {successText}
          </p>
        ) : (
          <form onSubmit={submit} className="flex w-full max-w-md gap-2">
            <div className="relative flex-1">
              <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                aria-label="Email address"
                className="w-full rounded-lg border border-slate-200 bg-white py-2.5 pl-9 pr-3 text-sm text-slate-900 outline-none focus:border-purple-400 focus:ring-2 focus:ring-purple-100"
              />
            </div>
            <button
              type="submit"
              disabled={state === "loading"}
              className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-purple-900 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-purple-800 disabled:opacity-70"
            >
              {state === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
              {buttonLabel}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
